export const CategoryIcons: string[] = [
  "🛍️",
  "📦",
  "🏷️",
  "🎁",
  "🛒",
  "🧾",
  "👕",
  "👚",
  "👔",
  "👗",
  "🧥",
  "🥼",
  "👖",
  "🩳",
  "🧦",
  "👟",
  "👞",
  "🥾",
  "👠",
  "👜",
  "🎒",
  "🧢",
  "👒",
  "🕶️",
  "💍",
  "⌚",
  "📱",
  "💻",
  "⌨️",
  "🖥️",
  "🖨️",
  "🎧",
  "📷",
  "🎮",
  "🔌",
  "🔋",
  "💡",
  "🏠",
  "🛋️",
  "🛏️",
  "🪑",
  "🧺",
  "🪞",
  "🪴",
  "🧸",
  "📚",
  "✏️",
  "🎨",
  "⚽",
  "🏋️",
  "🚲",
  "🚗",
  "🔧",
  "🧰",
  "🪛",
  "🧴",
  "💄",
  "💊",
  "🧼",
  "🍼",
  "🐾",
  "🌱",
  "🌸",
  "🍽️",
  "🥤",
  "☕",
  "🍎",
]
